import request from '@/utils/request'

// 获取报表配置列表
export function reportDefinitionReportDefinitionJson(data) {
	return request({
		url: '/ocs-report/reportDefinition/reportDefinitionJson',
		method: 'POST',
		data
	})
}

// 获取一份报表配置数据
export function reportExtractParamsAction(data) {
	return request({
		url: '/ocs-report/report/view/extractParamsAction',
		method: 'POST',
		data
	})
}

// 添加报表
export function reportDefinitionDefinitionAddJson(data) {
	return request({
		url: "/ocs-report/reportDefinition/definitionAddJson",
		method: 'POST',
		data
	})
}

// 编辑报表
export function reportDefinitionDefinitionEditJson(data) {
	return request({
		url: "/ocs-report/reportDefinition/definitionEditJson",
		method: 'POST',
		data
	})
}

// 执行报表查询&导出
export function reportViewExecutejson(data) {
	return request({
		url: "/ocs-report/report/view/executejson",
		method: 'POST',
		data
	})
}

// 报表数据源列表(适配器)
export function reportDefinitionListAdapter (){
	return request({
		url: "/ocs-report/reportDefinition/listAdapter",
		method: 'GET'
	})
}

// 删除报表定义
export function reportDefinitionDefinitionDeleteJson (data){
	return request({
		url: "/ocs-report/reportDefinition/definitionDeleteJson",
		method: 'POST',
		data
	})
}




// 添加报表查询条件
export function reportDefinitionItemAddJson (data){
	return request({
		url: "/ocs-report/reportDefinition/itemAddJson",
		method: 'POST',
		data
	})
}

// 报表项编辑
export function reportDefinitionItemEditJson (data){
	return request({
		url: "/ocs-report/reportDefinition/itemEditJson",
		method: 'POST',
		data
	})
}

// 删除报表项
export function reportDefinitionItemDeleteJson (data){
	return request({
		url: "/ocs-report/reportDefinition/itemDeleteJson",
		method: 'POST',
		data
	})
}

//报表项条件配置查询
export function reportDefinitionOptionListJson (data){
	return request({
		url: "/ocs-report/reportDefinition/optionListJson",
		method: 'POST',
		data
	})
}


//报表项配置添加(自定义接口)
export function reportDefinitionOptionInterfaceAddJson (data){
	return request({
		url: "/ocs-report/reportDefinition/optionInterfaceAddJson",
		method: 'POST',
		data
	})
}

//报表项配置添加
export function reportDefinitionOptionAddJson (data){
	return request({
		url: "/ocs-report/reportDefinition/optionAddJson",
		method: 'POST',
		data
	})
}

//报表配置选项修改
export function reportDefinitionOptionEditJson (data){
	return request({
		url: "/ocs-report/reportDefinition/optionEditJson",
		method: 'POST',
		data
	})
}

//报表项配置删除
export function reportDefinitionOptionDeleteJson (data){
	return request({
		url: "/ocs-report/reportDefinition/optionDeleteJson",
		method: 'POST',
		data
	})
}

// 导出待下载报表列表
export function asyncreportControllerAsyncreportList (data){
	return request({
		url: "/ocs-async-report/asyncreportController/asyncreportList",
		method: 'POST',
		data
	})
}

// 下载报表
export function asyncreportControllerDownloadAsyncreport (data){
	return request({
		url: "/ocs-async-report/asyncreportController/downloadAsyncreport",
		method: 'POST',
		data
	})
}